<template>
    <card class="simulation card-pricing bg-gradient-default border-0 text-center mb-2"
        header-classes="bg-transparent"
        body-classes="px-lg-7"
        footer-classes="bg-transparent"
        v-if="registration">

        <registration-info :registration="registration"></registration-info>

        <div class="display-3 text-white mb-3">
            {{ registration.degree.name }}
        </div>
    </card>
</template>

<script>
    import RegistrationInfo from '../../dashboard/common/RegistrationInfo'

    export default {

        components: {
            RegistrationInfo
        },

        props: {

            registration: {
                type: Object,
                required: true
            },
        },
    }
</script>

<style scoped>

    .card-pricing >>> .progress {
        background-color: #57587D;
    }
    .card-pricing >>> .help-button {
        top: 0.7rem;
        position: absolute;
        right: 1rem;
        font-size: 1.2rem;
    }

</style>
